import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useMemo, createContext, useContext, useState } from 'react';
import styles from './styles.module.scss';
import { TextS } from '../typography/typography';
import { useClickOutside } from '../../../small-tools/use-click-outside';
import { useBreakpoints } from '../../hooks/use-get-breakpoints';
var SelectContext = createContext(undefined);
export var Select = function (_a) {
    var children = _a.children, disabled = _a.disabled, errorMessage = _a.errorMessage, successMessage = _a.successMessage, InfoMessage = _a.InfoMessage, _b = _a.variation, variation = _b === void 0 ? 'regular' : _b;
    var triggerRef = useRef(null);
    var containerRef = useRef(null);
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useState(false), hasValue = _d[0], setHasValue = _d[1];
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    useClickOutside(containerRef, function () {
        if (isOpen && !isMobileOrSmaller) {
            setIsOpen(false);
        }
    }, ['data-select-content']);
    var contextValue = useMemo(function () { return ({
        isOpen: isOpen,
        toggleSelect: function () { return setIsOpen(!isOpen); },
        disabled: disabled,
        errorMessage: errorMessage,
        successMessage: successMessage,
        triggerRef: triggerRef,
        hasValue: hasValue,
        setHasValue: setHasValue,
    }); }, [isOpen, disabled, errorMessage, successMessage, triggerRef, hasValue, setHasValue]);
    var containerClass = "".concat(styles.container, " ").concat(variation === 'country' ? styles.country : '');
    return (_jsxs(SelectContext.Provider, { value: contextValue, children: [_jsx("div", { className: containerClass, ref: containerRef, children: children }), errorMessage && (_jsx(TextS, { color: "negative", className: styles['additional-message'], children: errorMessage })), successMessage && (_jsx(TextS, { color: "positive", className: styles['additional-message'], children: successMessage })), InfoMessage && (_jsx(TextS, { color: disabled ? 'disabled' : 'tertiary', className: styles['additional-message'], children: InfoMessage }))] }));
};
export var useSelect = function () {
    var context = useContext(SelectContext);
    if (!context) {
        throw new Error('SelectContext is not initialized. Make sure that useSelect is placed up the components tree.');
    }
    return context;
};
